/* Product Page CRO — keep coverage and refill-life in sync with the selected
   variant. Refill size comes from data-cro-size (product refill_size_ml), not
   a hardcoded 500 ml. Mirrors snippets/cro-usp-strip.liquid. */
(function () {
  function init() {
    var strip = document.querySelector('[data-cro-usp]');
    if (!strip || strip.dataset.croBound) return;

    var mapEl = document.querySelector('[data-cro-cov-map]');
    if (!mapEl) return;

    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var hpd  = parseFloat(strip.dataset.croHpd) || 8;
    var size = parseFloat(strip.dataset.croSize) || 0;

    var cbmEl  = strip.querySelector('[data-cro-cov-cbm]');
    var sqmEl  = strip.querySelector('[data-cro-cov-sqm]');
    var daysEl = strip.querySelector('[data-cro-life-days]');
    if (!cbmEl && !daysEl) return;

    strip.dataset.croBound = '1';

    function rates(str) {
      if (!str) return null;
      var m = String(str).match(/[\d.]+/g);
      if (!m || !m.length) return null;
      var lo = parseFloat(m[0]);
      var hi = parseFloat(m[m.length - 1]);
      return (lo > 0 && hi > 0) ? [Math.min(lo, hi), Math.max(lo, hi)] : null;
    }

    function paint(id) {
      var d = map[String(id)];
      if (!d) return;

      if (cbmEl && d.cbm) {
        cbmEl.textContent = Number(d.cbm).toLocaleString() + ' CBM';
        if (sqmEl) {
          sqmEl.textContent = 'about ' + Math.round(d.cbm / 3).toLocaleString() + ' m\u00B2 at 3 m ceiling';
        }
      }

      if (daysEl) {
        var li = daysEl.closest('.cro-usp__item');
        var text = '';

        if (d.days && Number(d.days) > 0) {
          text = 'about ' + Number(d.days) + ' days';
        } else if (size > 0) {
          var r = rates(d.rate);
          if (r) {
            var maxDays = Math.round(size / (r[0] * hpd));
            var minDays = Math.round(size / (r[1] * hpd));
            text = (maxDays > minDays)
              ? minDays + '\u2013' + maxDays + ' days'
              : 'about ' + minDays + ' days';
          }
        }

        if (text) {
          daysEl.textContent = text;
          if (li) li.hidden = false;
        } else if (li) {
          li.hidden = true;
        }
      }
    }

    function currentId() {
      var p = new URLSearchParams(window.location.search).get('variant');
      if (p) return p;
      var input = document.querySelector('input[name="id"], select[name="id"]');
      return input ? input.value : null;
    }

    var last = currentId();
    if (last) paint(last);

    function check() {
      var id = currentId();
      if (id && id !== last) { last = id; paint(id); }
    }

    document.addEventListener('change', check, true);
    document.addEventListener('click', function () { setTimeout(check, 60); }, true);
    window.addEventListener('popstate', check);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
